import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { PasswordGate } from './components/PasswordGate';
import './index.css';

// Stabilität bei Deploys: alte Lazy-Chunks verschwinden nach einem Deploy —
// offene Tabs würden bei Navigation leer laufen ("Seite weg"). Bei
// 'vite:preloadError' einmal neu laden (Schleifenschutz über sessionStorage).
window.addEventListener('vite:preloadError', (e) => {
  const KEY = 'tl_chunk_reload_ts';
  const last = Number(sessionStorage.getItem(KEY) || 0);
  if (Date.now() - last < 60_000) return;
  sessionStorage.setItem(KEY, String(Date.now()));
  e.preventDefault();
  window.location.reload();
});

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('Root element not found');

ReactDOM.createRoot(rootEl).render(
  <React.StrictMode>
    <PasswordGate>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </PasswordGate>
  </React.StrictMode>
);
